import { numberFormat } from "../../../util/currency-formatter";
import { Link } from "react-router-dom";
import { CONTRACTORS, WORK_ORDER } from "../../../constants/route-paths";

export const createWOFields = {
    project: {
        name: "project",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        validation: ["required"],
    },
    vendor: {
        name: "vendor",
        value: "",
        error: false,
        items: [],
        type: "select",
        valid: true,
        isFromProject: true,
        validation: ["required"],
    },
    quote_no: {
        name: 'quote_no',
        label: 'Quote No',
        type: 'text',
        touched: false,
        error: false,
        valid: true,
        value: '',
        isFromProject: true,
        validation: []
    },
    street_address: {
        name: "street_address",
        label: "Street Address",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [],
    },
    suburb: {
        name: "suburb",
        label: "Suburb",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [],
    },
    state: {
        name: "state",
        label: "State",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [],
    },
    postcode: {
        name: "postcode",
        label: "Postcode",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [],
    },
    country: {
        name: "country",
        label: "Country",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        validation: [],
    },
}

export const woListColumns = [
    {
        title: "WO Number",
        field: "id",
        render: (rowData) => (
            <Link to={`/${CONTRACTORS}/${WORK_ORDER}/view/${rowData.poId}/project`}>
                {rowData.f_id || rowData.id}
            </Link>
        ),
    },
    { title: "Vendor", field: "vendorName", dataCy: "vendor-name" },
    { title: "Project", field: "project", dataCy: "project" },
    {
        title: "WO Total",
        field: "woTotal",
        class: 'text-right',
        render: (rowData) => `${numberFormat(rowData.woTotal)}`,
        dataCy: "wo-total",
    },
    {
        title: "Amount Claimed",
        field: "amountClaimed",
        class: 'text-right',
        render: (rowData) => `${numberFormat(rowData.amountClaimed)}`,
        dataCy: "amount-claimed",
    },
    {
        title: "Retention",
        field: "retention",
        class: 'text-right',
        render: (rowData) => `${numberFormat(rowData.retention)}`,
        dataCy: "retention",
    },
    {
        title: "Approved",
        field: "approved",
        class: 'text-right',
        render: (rowData) => `${numberFormat(rowData.approved)}`,
        dataCy: "approved",
    },
    { title: "Issue Date", field: "issueDate", dataCy: "issue-date" },
    {
        title: "Status",
        field: "status",
        render: (rowData) => {
            let className = '';
            if (rowData.status === 'Active' || rowData.status === 'Partially Stocked' || rowData.status === 'Pending') className = 'text-warning';
            else if (rowData.status === 'Inactive' || rowData.status === 'Completed') className = 'text-success';
            else if (rowData.status === 'Cancelled') className = 'text-danger';

            return <span className={className} data-cy="status">{rowData.status}</span>;
        },
    },
]